export default {
  common: {
    email: 'Email',
    password: 'Contraseña',
    edit: 'Editar',
    update: 'Modificar',
    cancel: 'Cancelar',
    delete: 'Borrar'
  },
  home: {
    logout: 'Desconexión'
  },
  auth: {
    notRegistered: '¿No está registrado?',
    forgotPassword: 'He perdido mi contraseña',
    forgotPasswordContent: 'Ingrese su correo electrónico de GOWOD, se le enviará una contraseña temporal que le permitirá iniciar sesión.\nNo olvides cambiarlo desde la configuración de la aplicación.',
    localstorageError: 'Parece que las cookies están bloqueadas en su navegador. Este sitio solo los utiliza para almacenar datos de autenticación, habilite las cookies.',
    signIn: 'Conexión',
    modal: {
      title: 'El registro a GOWOD se hace desde la aplicación móvil',
      content: 'La aplicación está disponible para Android e iOS'
    },
    signinFacebook: "Conexión con Facebook",
    signinGoogle: "Conexión con Google",
  },
  tabs: {
    profile: 'Perfil',
    pdata: 'Datos personales',
    premium: 'GOWOD Premium',
    gifts: 'Tarjetas de Regalo'
  },
  profile: {
    firstname: 'Nombre',
    lastname: 'Apellido',
    age: 'Edad',
    sex: 'Sexo',
    affiliate: 'Afiliado',
    country: 'País',
    birthdate: 'Fecha de nacimiento'
  },
  sex: {
    MALE: 'Hombre',
    FEMALE: 'Mujer',
    OTHER: 'Otros'
  },
  pdata: {
    title: 'Los datos personales recogidos por GOWOD para su correcto funcionamiento son:',
    part1: 'Datos del perfil: apellidos, nombre, edad, sexo, casilla asociada y país',
    part2: 'Resultados de las pruebas de movilidad: respuestas, puntuaciones, perfil configurado',
    part3: 'Los protocolos generados para uso estadístico: fecha, duración seleccionada, tipo (pre/post WOD, diario) y los movimientos seleccionados.',
    manage: 'MANEJO DE INFORMACIÓN',
    download: 'Descargar mis datos',
    delete: 'Borrar mi cuenta',
    deleteModal: {
      title: 'Borrar la cuenta de GOWOD',
        part1: '¿Estás seguro que quieres borrar tu cuenta de GOWOD?',
        part2: 'Esta acción borrará su cuenta así',
        part3: 'definitivo e irreversible',
        part4: 'Nota: si está suscrito a través de iTunes, la eliminación de su cuenta NO LO DESCONSTITUIRÁ.',
        part5: 'Sigue este enlace para ayudarte a darte de baja de iTunes'
    }
  },
  promoTuto: {
    line1: 'Cómo usar su código de promoción " COMMUNITY "?',
    line2: '40 DÍAS DE PRUEBA GRATIS',
    step1: "Elija una de las siguientes ofertas",
    step2: 'Haga clic en suscribirse',
    step3: 'Haga clic en "Tengo un código de promoción" (sólo presente si la primera inscripción)',
    step4: 'Introduce tu código de promoción: COMMUNITY',
    step51: 'Cancele en cualquier momento antes de que termine el juicio',
    step52: 'que no se facturen',
    step53: "si no quieres continuar",
    warning: "Atención: Oferta válida sólo en su primera inscripción"
  },
  premium: {
    authenticatePayment: "Autentificar el pago",
    seeInvoice: "Resolver el problema",
    premiumUnlocks: 'GOWOD Premium te da acceso al test de movilidad mensual que te permitirá determinar el eje de movilidad más rentable para mejorar para ti, así como a todos los protocolos de movilidad PRE-WOD POST-WOD y Daily, configurados en tu punto débil para que progreses eficientemente.',
    premiumSlogan: 'Movilidad fácil y personalizada',
    point1: 'Mejore el rendimiento de su WOD',
    point2: 'Facilitar la adquisición de la técnica óptima',
    point3: 'Optimiza la transferencia de fuerzas',
    point4: 'Acelere su recuperación',
    point5: 'Reducir el riesgo de lesiones',
    freeTrial: '14 días de prueba gratuita para el primer registro' ,
    monthly: ' Mensual',
    halfYearly: 'Semestral',
    yearly: ' Anual',
    subscribe: 'Suscríbete',
    perMonth: '/ mes',
    per6Months: '6 meses',
    perYear: '/ año',
    subscriptionFrom: 'Suscriptor desde',
    pausedUntil: 'Suscripción en pausa hasta',
    nextBilling: 'Próxima facturación',
    changePlan: 'Plan de cambio',
    confirm: 'Confirme',
    reactivateSub: 'Reactivar la suscripción',
    unpauseSub: 'Reanudar la suscripción',
    unpauseText: 'Está a punto de reiniciar su suscripción, reinicie la aplicación GOWOD una vez realizada para recuperar el acceso a GOWOD Premium.',
    unpause: 'Reactivar',
    break: 'Puedes tomarte un descanso en lugar de eso!',
    pauseFor: 'Haga una pausa en su cuenta para:',
    oneMonth: '1 mes',
    twoMonths: '2 meses',
    threeMonths: '3 meses',
    pauseText: 'No se le cobrará durante su descanso, su suscripción y acceso a GOWOD Premium se reanudará al final de este periodo. También puede reanudar la suscripción cuando lo desee.',
    pauseSub: 'Suspender mi suscripción',
    noThanks: 'No, gracias, cancela la suscripción',
    month: 'meses',
    promocode: 'Código de promoción',
    signupDate: 'Fecha de suscripción',
    accessUntil: 'Acceso hasta',
    firstBilling: 'Primera facturación',
    currentPeriod: 'Período actual',
    status: 'Estado',
    cancelAtEnd: 'Anulado al final del período actual',
    changePlanTitle: "Cambiar su suscripción",
    changePlanContent: "Si se encuentra en un período de prueba, se conservará y su nuevo plan se facturará al final del período de prueba.\nSi no, su suscripción cambiará de plan inmediatamente y se le facturará una cantidad prorrateada por el nuevo plan, teniendo en cuenta la parte utilizada del plan anterior.",
    statuses: {
      active: 'Activo',
      trialing: 'Período de prueba en curso',
      past_due: 'Problemas de pago',
      unpaid: 'Problemas de pago',
      incomplete: 'Se necesita autenticación'
    },
    updateCC: 'Actualizar tarjeta de crédito',
    updateModal: {
      title: 'Actualización de tarjetas de crédito',
      content: 'Por favor, introduzca la información de su nueva tarjeta:'
    },
    unsubscribe: 'Darse de baja',
    successModal: {
      title: "Suscripción exitosa!",
      part1: "Felicidades, ya eres un miembro de GOWOD Premium!",
      part2: "Por favor, cierre y vuelva a abrir su aplicación GOWOD para que su acceso Premium sea tenido en cuenta."
    },
    unsubModal: {
      title: 'Confirmación de cancelación de la suscripción',
      part1: '¿Podrías tomarte un momento para ayudarnos a mejorar diciéndonos por qué te vas?',
      mail: 'Si tiene algún problema, puede enviarnos un correo electrónico directamente a ',
      part2: 'Usted tendrá acceso a GOWOD Premium hasta el final del período establecido.',
      confirm: 'Confirmar',
      reason1: "No lo uso lo suficiente",
      reason2: "Demasiado caro",
      reason3: "No es lo suficientemente eficiente",
      reason4: "Otros",
      addon: "¿Algo que quieras compartir? (Opcional)"
    },
    storesModal: {
      title: 'Darse de baja de les app stores',
      part1: 'Parece que tu registro a GOWOD Premium fue hecho a través de una de las persianas.',
      part2: 'Puede darse de baja del toldo correspondiente a su plataforma.',
      part3: 'Puede consultar estos enlaces si necesita ayuda:',
    },
    subscribeModal: {
      title: 'Suscripción a GOWOD Premium',
      havePromocode: 'Tengo un código de promoción',
      validate: 'Validar',
      invalidCode: 'Código inválido',
      validCode1: 'Código válido',
      validCode2: 'días de prueba gratuita',
    },
    promocodeModal: {
      link: "Tengo un código de promoción",
      title: "Uso de un código promocional",
      intro: "Los códigos promocionales te permiten extender el período de prueba de tu suscripción a GOWOD Premium",
      intro2: "Sólo se pueden usar en tu primera suscripción.",
      step1: "Seleccione la facturación deseada (mensual o semestral) y haga clic en el botón correspondiente",
      step2: "Se abre la ventana emergente de registro y si esta es su primera suscripción, active el cambio de código de promoción",
      step3: "Introduzca su código en el campo y valídelo con el botón",
      step4: "Si su código es válido, verá un mensaje de validación que confirma la duración del período de prueba",
      step5: "Ahora puede rellenar sus datos de pago y continuar con su registro"
    }
  },
  messages: {
    welcome: 'Bienvenido {{firstname}}',
    error: 'Se ha producido un error',
    updateOK: 'Actualizado con éxito!',
    updateKO: 'Se ha producido un error al actualizar el perfil',
    subscribeOK: 'Registro de GOWOD Premium exitoso!',
    subscribeKO: 'Se ha producido un error al registrarse para la prima',
    cardInvalid: 'Tarjeta no válida',
    cardUpdateOK: 'Actualización exitosa de mapas',
    cardUpdateKO: 'Se ha producido un error al actualizar el mapa',
    cancelOK: 'Cancelar suscripción con éxito',
    cancelKO: 'Se ha producido un error al cancelar la suscripción',
    premiumInfoKO: 'Se produjo un error al recuperar la información de la prima',
    deleteKO: 'Se ha producido un error al recuperar sus datos personales',
    pdataKO: 'Se ha producido un error al borrar su cuenta',
    wrongCardData: 'Datos de la tarjeta inválidos',
    resetOK: 'Contraseña temporal enviada',
    pauseOK: 'Suscripción en pausa',
  },
  giftCards: {
    noiTunes: 'El código de regalo tiene la forma XXXX-XXXX-XXXX, ten en cuenta que si te registras a través de iTunes o Google Play, el código no tendrá ningún efecto.<br/>Para conocer el procedimiento para pasar de iTunes a nuestro sitio web, envíe un correo electrónico a <strong style="color:#6499FF">help@gowod.eu</strong>',
    enterCode: 'Para utilizar su tarjeta de regalo, por favor, introduzca el código:',
    successMessage: 'Su gato de regalo ha sido aplicado! Reinicia la aplicación y ya deberías tener acceso a GOWOD Premium.',
    redeem: 'Aplique'
  }
}


// WEBPACK FOOTER //
// ./src/languages/es.js